import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { Box, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { CustomizedBox } from "../../../Custom/CustomizedBox";
import { CustomizedTooltip } from "../../../Custom/CustomizedTooltip";
import BillingAddressModal from "../../../UI/Modal/BillingAddressModal";
import PurchaseDeliveryAddressModal from "../../../UI/Modal/PurchaseDeliveryAddressModal";

import { useModal } from "../../../../hooks/use-modal";
import { useDisable } from "../../../../hooks/use-disable";
import { countryFormatter } from "../../../../utils/Formatter/Global";
import SubHeader from "../../Purchase/SubHeader";
import DeliveryAddressModal from "../../../UI/Modal/DeliveryAddressModal";

type Props = {
  disabledField?: boolean;
  documentType?: string;
};

const AddressInfo = ({ disabledField, documentType }: Props) => {
  const { t } = useTranslation();
  const [disabled] = useDisable();

  const { control, getValues, watch } = useFormContext();

  const {
    modal: openDeliveryAddress,
    openModalHandler: openDeliveryAddressHandler,
    closeModalHandler: closeDeliveryAddress,
  } = useModal();

  const renderAddressString = (values: string) => {
    const addressValues = getValues(`customer_details[${values}]`);
    if (addressValues) {
      const {
        address_name,
        sub_district,
        district,
        province,
        postal_code,
        country,
      } = addressValues;

      const orderedValues = {
        address_name,
        sub_district,
        district,
        province,
        postal_code,
        country,
      };
      let result = "";

      if (addressValues && orderedValues) {
        if (Array.isArray(addressValues)) {
          addressValues.forEach((item) => {
            if (item?.length > 0) {
              result = result + item + ", ";
            }
          });
        } else {
          const keys = Object.keys(orderedValues);
          keys.forEach((key) => {
            let newValue = "";
            if (key === "country") {
              newValue =
                countryFormatter(
                  orderedValues[key as keyof typeof orderedValues]
                ) || "";
            } else {
              newValue = orderedValues[key as keyof typeof orderedValues];
            }

            if (newValue && newValue.length > 0) {
              result = result + newValue + ", ";
            }
          });
        }
        if (result?.trim().length === 0) {
          return "-";
        }
      }
      // remove whitespace and last comma
      return result?.trim().slice(0, -1);
      // remove whitespace and last comma
    } else return "-";
  };

  const renderAddressContact = () => {
    const addressValues = getValues("customer_details.delivery_address");

    if (addressValues) {
      const { contact_name, contact_phone } = addressValues;

      if (contact_name && contact_phone) {
        const result = `${contact_name}, ${contact_phone}`;
        return result;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  return (
    <Fragment>
      <CustomizedBox margin={0}>
        <Box display="flex" gap={1} alignItems="center">
          <SubHeader title={t("address.delivery_address")} />
          {!disabled && !disabledField ? (
            <CustomizedTooltip title={`แก้ไข${t("address.delivery_address")}`}>
              <IconButton onClick={openDeliveryAddressHandler} color="primary">
                <EditIcon />
              </IconButton>
            </CustomizedTooltip>
          ) : null}
        </Box>
        <Typography>{renderAddressContact()}</Typography>
        <Typography>{renderAddressString("delivery_address")}</Typography>
      </CustomizedBox>
      <DeliveryAddressModal
        name="customer_details"
        open={openDeliveryAddress}
        handleClose={closeDeliveryAddress}
        viewMode={false}
        disabledSameButton
      />
    </Fragment>
  );
};

export default AddressInfo;
